// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fr-form-field[data-v-60259a4a]{box-sizing:border-box;width:100%}.fr-form-field>div[data-v-60259a4a]{margin-bottom:10px}.half-width[data-v-60259a4a]{width:50%;padding-right:5px}@media screen and (max-width:480px){.half-width[data-v-60259a4a]{width:100%;padding-right:0}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
